import GatsbyImage, { FluidObject, GatsbyImageProps } from 'gatsby-image';
import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { primaryColor } from '../../../utils/styles';
import { useAccordionContext } from '../context';

export interface AccordionHeader extends Omit<HTMLAttributes<HTMLButtonElement>, 'onClick'> {
  id: string;
  index: number;
  textSize?: 'body' | 'small';
  fluid?: FluidObject | FluidObject[];
  onClick?: (isActive: boolean) => void;
}
const StyledButton = styled.button`
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  width: 100%;
  padding: 24px;
  outline: none;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: left;
  width: 100%;
  justify-content: space-between;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
`;

const Cross = styled.span<{ active: boolean }>`
  flex-shrink: 0;
  width: 11px;
  height: 11px;
  position: relative;
  margin-left: 24px;
  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: ${primaryColor};
  }
  &:before {
    width: 100%;
    height: 3px;
  }
  &:after {
    height: ${({ active }) => (active ? '0' : '100%')};
    width: 3px;
  }
`;

const HeaderImage = styled(GatsbyImage).attrs({
  loading: 'lazy',
})<GatsbyImageProps>`
  width: 140px;
  height: 100%;
  margin-right: 24px;
`;

const AccordionHeader: FC<AccordionHeader> = ({ children, id, index, onClick, fluid, ...rest }) => {
  const { getHeaderProps, isActiveSection } = useAccordionContext();
  const { ref, onClick: contextOnClick, ...headerPropsRest } = getHeaderProps(id, index);

  const handleClick = () => {
    onClick && onClick(isActiveSection(index));
    contextOnClick();
  };

  return (
    <StyledButton type="button" ref={ref} onClick={handleClick} {...headerPropsRest} {...rest}>
      <TitleContainer>
        <Content>
          {fluid && <HeaderImage fluid={fluid} />}
          {children}
        </Content>
        <Cross active={isActiveSection(index)} />
      </TitleContainer>
    </StyledButton>
  );
};

export default AccordionHeader;
